/**
 * Portal Init Redux Slice
 * Actions and reducer for portal initialization state
 */

import { createSlice } from '@spcc/core'
import type { PayloadAction } from '@spcc/core'
import type { PortalInitState, InitData } from '../domain/types'

// ============================================================================
// Initial State
// ============================================================================

const initialState: PortalInitState = {
  status: 'idle',
  data: null,
  error: null,
  lastInitialized: null,
}

// ============================================================================
// Slice
// ============================================================================

const initSlice = createSlice({
  name: 'portalInit',
  initialState,
  reducers: {
    /**
     * Trigger portal initialization (saga intercepts this)
     */
    initialize: (state) => {
      state.status = 'loading'
      state.error = null
    },

    /**
     * Initialization succeeded
     */
    initializeSuccess: (state, action: PayloadAction<InitData>) => {
      state.status = 'success'
      state.data = action.payload
      state.error = null
      state.lastInitialized = new Date().toISOString()
    },

    /**
     * Initialization failed
     */
    initializeFailure: (state, action: PayloadAction<string>) => {
      state.status = 'error'
      state.error = action.payload
    },

    /**
     * Reset state (on logout)
     */
    reset: () => initialState,

    /**
     * Clear error only
     */
    clearError: (state) => {
      state.error = null
    },
  },
})

// ============================================================================
// Exports
// ============================================================================

export const initActions = initSlice.actions
export const initReducer = initSlice.reducer
